module.exports = __webpack_public_path__ + "static/media/banner-verde-mobile.5f3decc9.png";